import React, { useState } from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Image as ImageIcon } from 'lucide-react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Mock gallery images - in real scenario, these would come from the actual gallery page
  const galleryImages = [
    'https://davcommercesolapur.com/images/slider/1.jpg',
    'https://davcommercesolapur.com/images/slider/2.jpeg',
    'https://davcommercesolapur.com/images/slider/3.jpeg',
    'https://davcommercesolapur.com/images/slider/5.jpeg',
    'https://davcommercesolapur.com/images/slider/6.jpeg',
    'https://davcommercesolapur.com/images/slider/7.jpeg',
    'https://davcommercesolapur.com/images/slider/8.jpeg',
    'https://davcommercesolapur.com/images/slider/9.jpeg',
    'https://davcommercesolapur.com/images/slider/10.jpeg',
    'https://davcommercesolapur.com/images/slider/11.jpeg',
    'https://davcommercesolapur.com/images/slider/12.jpeg'
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Navigation />
      
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-[#000066] mb-2 flex items-center gap-3">
            <ImageIcon className="w-10 h-10" />
            Event Photo Gallery
          </h1>
          <p className="text-gray-600">Browse through our college events and activities</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="relative group cursor-pointer overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image}
                alt={`Gallery ${index + 1}`}
                className="w-full h-64 object-cover"
              />
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <p className="text-white font-semibold">Click to view</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-5xl w-full">
            <button
              className="absolute -top-12 right-0 text-white text-4xl hover:text-gray-300"
              onClick={() => setSelectedImage(null)}
            >
              ×
            </button>
            <img
              src={selectedImage}
              alt="Selected"
              className="w-full h-auto max-h-[80vh] object-contain"
            />
          </div>
        </div>
      )}
      
      <Footer />
    </div>
  );
};

export default Gallery;